class QuickView extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-view-external-el="trigger"]',
    )

    if (!trigger) return

    this.setAttribute('aria-busy', 'true')
    this.els.body.element.innerHTML = ''
    window.drawers.activeDrawerKey = 'quick-view'

    await window.BAO.sectionRenderer
      .fetchSingle('quick-view', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.drw-QuickView')
        this.els.body.element.innerHTML = bodyContent.outerHTML

        window.yotpoWidgetsContainer?.initWidgets()
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
      .finally(() => {
        this.removeAttribute('aria-busy')
      })
  }
}

if (!customElements.get('quick-view')) {
  customElements.define('quick-view', QuickView)
}
